import dayjs from 'dayjs';

import { BaseComponentProps } from 'types/components';

export enum DateField {
  START_DATE = 'startDate',
  END_DATE = 'endDate',
}

export interface IDateFilterValue {
  [DateField.START_DATE]?: string;
  [DateField.END_DATE]?: string;
}

export type DateChangeArg = [DateField, string | null, dayjs.Dayjs];

export interface IDateFilterProps extends BaseComponentProps {
  value: IDateFilterValue;
  size?: 'large' | 'middle' | 'small';
  onChange: (arg1: DateChangeArg, arg2: DateChangeArg) => void;
}
